import { getPath } from '@/router/common'

const baseUrl = {
  title: '大车费增减款',
  path: 'CarFreightChange'
}

export default [
  {
    path: getPath('vehicle_info', baseUrl),
    name: 'CarFreightChange_vehicle_info',
    component: () => import(/* webpackChunkName: "CarFreightChange_vehicle_info" */ '@/views/carFreightChange/vehicle_info/index.vue'),
    meta: {
      title: '大车费增减款'
    }
  }
]
